<template>
    <div class="dialog-box">
        <el-dialog 
        title="绑定终端" 
        v-model="dialogVisible" 
        :before-close="handleClose">
        <!-- <span>这是一段信息</span> -->
            <el-form class="form-box">
                <el-form-item :label='`IMEI${index+1}`' v-for="(item,index) in listBox" prop="username" label-width="120px">
                    <el-input v-model="item.value" autocomplete="off" ></el-input>
                </el-form-item>
                <div class="buttom-box">
                    <el-button type="primary" @click="onSubmit">提交</el-button>
                    <el-button @click="handleClose">返回</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
import {bindDevice,BindImeiList} from '@/assets/api/logapi'
import { ElMessage } from 'element-plus'
export default {
    props: ['BindingAddObj'],
    data() {
        return {
            dialogVisible: true,
            form: {
                memberUserName: '1'
            },
            tableData:[],
            imei:'',
            listBox: [
                {
                    value: '',
                },
                {
                    value: '',
                },
                {
                    value: '',
                },
                {
                    value: '',
                },
                {
                    value: '',
                },
                {
                    value: '',
                },
                {
                    value: '',
                },
                {
                    value: '',
                },
                {
                    value: '',
                },
                {
                    value: '',
                },

            ]
        }

    },
    created(){
        this.ImeiList()
    },
    methods: {
        handleClose() {
            this.$emit('BindingAddClick')
        },
        onSubmit () {
            console.log('创建111',this.BindingAddObj);
            let imeiList = []
            for (let item of this.listBox) {
                if (item.value != '') {
                    imeiList.push(item.value)
                }
            }
            if (imeiList.length>0) {
                // console.log('有值',imeiList);
                let params = {
                    imeiList ,
                    memberId: this.BindingAddObj.memberId,
                    loginUserId:JSON.parse(localStorage.getItem('user')).id,

                }
                bindDevice(params).then((res)=> {
                    // this.handleExport(res.data,'数据报表.xls')
                    this.handleClose()
                    console.log(res,'绑定终端');
                }).catch((err)=> {
                    // ElMessage.error("绑定终端失败"+ err)
                    // this.$message({
                    // type: 'error',
                    // message: err.response.data.msg});
                    console.log(err,'999999999999');
                    this.$message({
						type: 'error',
						message: err.response.data.msg
					});
                    
                })
            } else {
                // console.log('没值，不可提交');
                ElMessage.error("请填写表单")
            }
           
        },
        ImeiList(){
            const params = {
                memberId:this.BindingAddObj.memberId
            }
            BindImeiList(params).then((res) => {
                console.log(res);
                if ( res.data.data.length ) {
                    res.data.data.forEach((item,index) => {
                        this.listBox[index].value = item.imei
                    });
                }
            }).catch((err)=> {
                // console.log(err);
                this.$message({
					type: 'error',
					message: err.response.data.msg || '接口异常'
				});
            })
        }

    }
}
</script>
<style scoped lang="scss" >
.dialog-box {
    .buttom-box {
        text-align: center;
    }
    :deep() {
        .el-dialog__header {
            text-align: center;
        }
        .el-dialog {
            width: 550px !important;
        }
    }
}
.form-box {
    :deep() {
        .el-form-item__label {
            text-align: left;
        }
        .el-input {
            width: 280px;
            // height: 35px;
            // line-height: 35px;
        }
        .el-button--small {
            padding: 15px 25px;
        }
    }
}
</style>